import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

// Rein informativer Hinweis — es werden keine Tracking-Cookies eingesetzt.
// Das Schließen wird bewusst NICHT gespeichert (kein Cookie/localStorage dafür).
export default function CookieTab() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 2000);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="cookie-tab"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed z-[80] bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-xs bg-[#0f0f14]/90 backdrop-blur-md border border-white/10 p-5"
        >
          <button
            data-testid="cookie-tab-close"
            onClick={() => setOpen(false)}
            aria-label="Schließen"
            className="absolute top-3 right-3 p-1.5 text-[#64646e] hover:text-[#f5f3ef] transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>
          <p className="font-mono2 text-[10px] tracking-[0.35em] text-[#38bdf8] uppercase">Cookies</p>
          <p className="mt-3 text-xs text-[#a3a3ac] font-light leading-relaxed">
            Diese Website verwendet derzeit keine Cookies zu Analyse-, Werbe- oder Trackingzwecken. Weitere
            Informationen findest du in der Datenschutzerklärung.
          </p>
          <Link
            data-testid="cookie-tab-link"
            to="/datenschutz"
            onClick={() => setOpen(false)}
            className="mt-4 inline-block font-mono2 text-[10px] tracking-[0.3em] text-[#f5f3ef] uppercase border-b border-[#38bdf8]/50 pb-1 hover:text-[#70c7fa] transition-colors"
          >
            Datenschutz
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
